import styled from 'styled-components';
import { Icon } from '../../../icon';

export const EmptyComponentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
    background-color: ${props => props.theme.emptyState.background};
      border-radius: 4px;
    padding: 16px;
    color: ${props => props.theme.emptyState.text.color};
`;

export const StyledIcon = styled(Icon)`
	font-size: 24px;
    background-color: ${props => props.theme.emptyState.icon.background};
    color: ${props => props.theme.emptyState.icon.color};
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
